<template>
  <div>
    <ts-page-title
      :title="$t('transferTransaction.pageTitle')"
      :breadcrumb="[
        { text: $t('home'), href: '/' },
        { text: $t('transferTransaction.pageTitle'), active: true }
      ]"
    />
    <ts-panel>
      <ts-panel-wrapper>
        <div class="row">
          <label
            class="form-col-label control-label required ts-pr-4 ts-p-2 "
            >{{ $t('transferTransaction.transferDate') }}</label
          >
          <div class="col-md-3 form-group ts-px-2 ts-h-8">
            <a-range-picker
              style="width:100%;"
              v-model="model.date_range"
              @change="fetchData()"
              format="DD-MM-YYYY"
              valueFormat="DD-MM-YYYY"
              :allowClear="false"
            />
            <div class="validate" v-if="errors.has('date_range')">
              {{ errors.first('date_range') }}
            </div>
          </div>
          <Button
            class="ts-ml-3"
            type="success"
            :disabled="exporting"
            :loading="exporting"
            ghost
            @click="exportExcel"
          >
            <Icon type="ios-document-outline" />{{ $t('excel') }}
          </Button>
        </div>
      </ts-panel-wrapper>
      <Table
        :columns="columns"
        :data="resources"
        size="small"
        :loading="loading"
        max-height="700"
      >
      </Table>
      <div class="ts-flex ts-items-center ts-justify-end ts-p-4">
        <ts-i-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-i-pagination>
      </div>
    </ts-panel>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import { mapState } from 'vuex'
import * as FileDownload from 'downloadjs'
import { trim, debounce } from 'lodash'

export default {
  name: 'transfer-transaction',
  components: {},
  data() {
    return {
      errors: new Errors(),
      loading: false,
      exporting: false,
      model: {
        date_range: [
          moment()
            .startOf('month')
            .format('DD-MM-YYYY'),
          moment()
            .endOf('month')
            .format('DD-MM-YYYY')
        ],
        date_type: 'transfer_date'
      }
    }
  },
  computed: {
    ...mapState('report/transferTransaction', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.report.transferTransaction.search
      },
      set(newValue) {
        this.$store.commit('report/transferTransaction/SET_SEARCH', newValue)
        this.$store.commit('report/transferTransaction/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        {
          title: this.$t('transferTransaction.transactionNo'),
          key: 'transfer_no',
          minWidth: 128
        },
        {
          title: this.$t('transferTransaction.transactionDate'),
          key: 'transfer_date',
          minWidth: 160
        },
        {
          title: this.$t('transferTransaction.fromLocation'),
          key: 'from_location_name',
          minWidth: 160
        },
        {
          title: this.$t('transferTransaction.toLocation'),
          key: 'to_location_name',
          minWidth: 160
        },
        {
          title: this.$t('transferTransaction.transferBy'),
          key: 'transfer_by',
          minWidth: 130
        },
        {
          title: this.$t('transferTransaction.confirmStatus'),
          key: 'confirmed_status',
          minWidth: 130
        },
        {
          title: this.$t('transferTransaction.barcode'),
          key: 'barcode',
          minWidth: 130
        },
        {
          title: this.$t('transferTransaction.productName'),
          key: 'product_name_en',
          minWidth: 130
        },
        {
          title: this.$t('transferTransaction.quantity'),
          key: 'quantity',
          minWidth: 130
        }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('report/transferTransaction/fetch', {
          date_range: this.model.date_range,
          ...attributes
        })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    exportExcel() {
      this.exporting = true
      this.errors = new Errors()
      this.$store
        .dispatch('report/transferTransaction/transferTransactionExcel', {
          date_range: this.model.date_range
        })
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.exporting = false))
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('report/transferTransaction/RESET_STATE'), next()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>
